/**
 * Google Maps API Loader (v2)
 *
 * Provides utilities for loading and initializing Google Maps API
 * for the address autocomplete feature.
 *
 * Uses @googlemaps/js-api-loader v2 functional API (setOptions + importLibrary)
 */
import {
  setOptions,
  importLibrary as gmImportLibrary,
} from "@googlemaps/js-api-loader";

let optionsConfigured = false;

/**
 * Ensure Google Maps API options are configured (called once)
 */
const ensureOptionsConfigured = (): void => {
  if (optionsConfigured) return;

  const apiKey = import.meta.env.VITE_GOOGLE_MAPS_API_KEY;
  if (!apiKey) {
    throw new Error(
      "VITE_GOOGLE_MAPS_API_KEY is not configured. Please add it to your .env file.",
    );
  }

  setOptions({
    key: apiKey,
    v: "weekly",
  });

  optionsConfigured = true;
};

/**
 * Import the Google Places library on-demand
 * Replaces the old Loader.importLibrary("places") pattern
 */
export const importPlacesLibrary =
  async (): Promise<google.maps.PlacesLibrary> => {
    ensureOptionsConfigured();
    return gmImportLibrary("places");
  };

